<script>
    import Footer from '../landing_page/footer.svelte';
    import Navbar from '../navbar/navbar.svelte';
    import NavbarMenu from '../navbar/navbar_menu.svelte';
    const {title} = rpcjs.props;
    title.set('Alumni');
    let moving;
    const slider = [
        {
            image: '/images/alumni/SurbhiSarna.png',
        },
        {
            image: '/images/alumni/Denny Liu.png',
        },
        {
            image: '/images/alumni/PatrickDai.png',
        },
        {
            image: '/images/alumni/CarlyMar.png',
        },
    ];
    const blog = [
        {
            blogsimage:
                '/images/Blogs/Christopher+Swenor_1920+x+1080+Thumbnail.png',
            name: 'Asra Nadeem,',
            date: 'Nov 05, 2021',
            Title: 'Blockchain with Christopher Swenor (CEO of Reach)',
            like: false,
        },
        {
            blogsimage: '/images/Blogs/Addie+Wagenknecht+1920+x+1080.png',
            name: 'Asra Nadeem,',
            date: 'Oct 22, 2021',
            Title: 'Talking About the Future of Blockchain with Addie Wagenknecht',
            like: false,
        },
        {
            blogsimage:
                '/images/Blogs/01-What-is-a-business-incubator-and-how-does-it-work 1.png',
            name: 'Draper University, ',
            date: 'May 22, 2020',
            Title: 'What Is a Business Incubator and How Does It Work?',
            like: false,
        },
    ];

    const section3 = [
        {
            image: '/images/alumni/section3/1.png',
            name: 'Adegoke<br> Olubusi',
            date: 'Summer 2014',
            content: 'Helium Health',
        },
        {
            image: '/images/alumni/section3/2.png',
            name: 'Akshay <br>Chaturvedi',
            date: 'Spring 2015',
            content: 'Leverage Edu',
        },
        {
            image: '/images/alumni/section3/3.png',
            name: 'Amira <br> Geneid',
            date: 'Fall 2014',
            content: 'Zahara',
        },
        {
            image: '/images/alumni/section3/4.png',
            name: 'Andrew <br> Martz',
            date: 'Spring 2013',
            content: 'Archform',
        },
        {
            image: '/images/alumni/section3/5.png',
            name: 'Benjamin <br>Ries',
            date: 'Summer 2013',
            content: 'Roby',
        },
        {
            image: '/images/alumni/section3/6.png',
            name: 'Brian <br>Friedman',
            date: 'Summer 2013,',
            content: 'Loopd Inc',
        },

        {
            image: '/images/alumni/section3/7.png',
            name: 'Thomas <br> Bragg',
            date: 'Pilot 2012',
            content: 'Yes Theory',
        },
        {
            image: '/images/alumni/section3/8.png',
            name: 'Travis<br> Wu',
            date: 'Summer 2015 ',
            content: 'LumiereVR',
        },
        {
            image: '/images/alumni/section3/9.png',
            name: 'Ebru<br> Yıldırım',
            date: 'Summer 2019',
            content: 'Ollang',
        },
        {
            image: '/images/alumni/section3/10.png',
            name: 'Guillaume <br>Rolland',
            date: 'Fall 2015',
            content: 'Sensorwake',
        },
        {
            image: '/images/alumni/section3/11.png',
            name: 'Harish <br>Gupta',
            date: 'Algorand 2021',
            content: 'Fxdx Exchange',
        },
        {
            image: '/images/alumni/section3/12.png',
            name: 'Josef<br> Rubin',
            date: 'Summer 2016',
            content: 'Escola Conquer',
        },

        {
            image: '/images/alumni/section3/13.png',
            name: 'Jude<br> Regev',
            date: 'OS June 2020',
            content: 'Jointer/Smartswap',
        },
        {
            image: '/images/alumni/section3/14.png',
            name: 'Konstantin',
            date: 'Summer 2017',
            content: 'TakeBus',
        },
        {
            image: '/images/alumni/section3/15.png',
            name: 'Kyung Rok <br>Moon',
            date: 'Fall 2014',
            content: 'Newsy Stock',
        },
        {
            image: '/images/alumni/section3/16.png',
            name: 'Luciano <br>Bueno',
            date: 'Spring 2015',
            content: 'GALY',
        },
        {
            image: '/images/alumni/section3/17.png',
            name: 'Matt <br>Blanchard',
            date: 'Algorand 2021 ',
            content: 'Cosmic Champs',
        },
        {
            image: '/images/alumni/section3/18.png',
            name: 'Michael<br> Lisovetsky',
            date: 'Summer 2015',
            content: 'Juice',
        },

        {
            image: '/images/alumni/section3/19.png',
            name: 'Rushikesh<br> Pawar',
            date: 'OS May 2021',
            content: 'Digital Zone',
        },
        {
            image: '/images/alumni/section3/20.png',
            name: 'Sahil<br> Dewan',
            date: 'Summer 2015 ',
            content: 'Harmony Protocol',
        },
        {
            image: '/images/alumni/section3/21.png',
            name: 'Scott<br> Edwards',
            date: 'Pilot 2012',
            content: 'Dropwater',
        },
        {
            image: '/images/alumni/section3/22.png',
            name: 'Sharon<br> Winter',
            date: 'Spring 2015',
            content: 'Esports One',
        },
        {
            image: '/images/alumni/section3/23.png',
            name: 'Taylor<br> Monks',
            date: 'Spring 2019',
            content: 'Basic Block',
        },
        {
            image: '/images/alumni/section3/24.png',
            name: 'Ted<br> Nivan',
            date: 'Algorand 2021',
            content: 'Exafinance',
        },

        {
            image: '/images/alumni/section3/25.png',
            name: 'Vinicius <br>Figueredo',
            date: 'Winter 2015 ',
            content: 'InEvent',
        },
        {
            image: '/images/alumni/section3/26.png',
            name: 'Vivek <br>Kopparthi',
            date: 'Fall 2015',
            content: 'Neolight',
        },
        {
            image: '/images/alumni/section3/27.png',
            name: 'Vova <br>Platov',
            date: 'Winter 2015',
            content: 'Slide Spiel',
        },
    ];
    const userMbl = {view_all_mbl: false};
    /**
    *
     */
    function toggleMbl() {
        userMbl.view_all_mbl = !userMbl.view_all_mbl;
    }
    // <!-- Google Tag Manager -->
    (function(w, d, s, l, i) {
        w[l]=w[l]||[]; w[l].push({'gtm.start':
        new Date().getTime(), 'event': 'gtm.js'}); const f=d.getElementsByTagName(s)[0];
        const j=d.createElement(s); const dl=l!='dataLayer'?'&l='+l:''; j.async=true; j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-N8TD4HQ');
    // <!-- End Google Tag Manager -->
</script>

<div class="desktop">
    <Navbar color_sent={'white'} />
    <div class="back-img">
            <img class="back-img-desktop" src="/images/alumni/alumni.JPG" alt="" width="100%" height="100%">
        <div style="
        position: absolute;
        top: 33.85vw;
        z-index: 30;
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
    ">
            <p class="heading">ALUMNI</p>
        </div>
            
    </div>
    <div class="section2">
        <div>
            <p class="paragraph1">
                DraperU Superheroes are developing ground-<br />breaking
                companies to help build a new future.
            </p>
        </div>
        <div class="main-border">
            <div class="border-div">
                <p class="border-text">3100<br />DRAPERU ALUMNI</p>
            </div>
            <div class="border-div">
                <p class="border-text">7000<br />NEW JOBS</p>
            </div>
            <div class="border-div">
                <p class="border-text">900M+<br />RAISED IN FUNDING</p>
            </div>
        </div>

        <div style="display:flex ;">
            <div>
                <p class="heading2">ALUMNI<br />SUPERSTARS</p>
            </div>
            <div
                class="next-btn"
                style=""
                on:click={() => {
                    if (moving.scrollLeft === 0) {
                        moving.scrollLeft += 1050;
                    } else {
                        moving.scrollLeft = 0;
                    }
                }}
            >
                <img
                    src="/images/aboutpage/arrow.svg"
                    alt=""
                    class="slider-arrow"
                />
            </div>
        </div>
            
            
        <div>
            <p class="slider-text">
                By joining Draper University,<br /> you will be a part of this
                alumni<br /> network that spans the globe.
            </p>
        </div>
        <div class="slider" style="" bind:this={moving}>
            {#each slider as i}
                <div style="position: relative;margin-right: 1.984vw;">
                    <div class="slider-image">
                        <img src={i.image} alt=" " width="100%" />
                    </div>
                </div>
            {/each}
        </div>

        <div class="gallery">
            {#each section3 as data}
                <div>
                    <div class="gallery_tab">
                        <img src={data.image} alt="" width="100%" />
                    </div>
                    <div><p class="sec3-name">{@html data.name}</p></div>
                    <div><p class="sec3-date">{data.date}</p></div>
                    <div><p class="sec3-content">{data.content}</p></div>
                </div>
            {/each}
        </div>
        <h1 class="superhero-heading">Superhero/Alumni Spotlight</h1>

        <div style="display: flex;margin-top: 3.930vw;">
            <div style="position:relative;left:7.407vw;">
                <div class="img-wrraper">
                    <img
                        src="/images/3boxesProgrampagesSection2.svg"
                        alt=""
                        width="100%"
                    />
                </div>
            </div>
            <div style="margin-top: 5vw;margin-left: -2.2vw;">
                <h1 style="font-size: 2.316vw;width: 68.620vw;color: #00204B;">
                    <div
                        style="width: 11vw;
                        margin-right: 2vw;
                        margin-bottom: 1vw;
                        display: inline-block;
                        border-radius: 1.5vw;
                        border-bottom: 0.3vw solid rgb(247, 224, 95);
                        transform: scale(1);"
                    />
                    Behind every great founder lies an even more impressive journey.
                    For our alumni, the road to success can offer many valuable lessons.
                    Through our Alumni Spotlight series, we have the opportunity
                    to get a look behind the scenes at the stories of these impressive
                    founders.
                </h1>
            </div>
        </div>

        <div style="display: flex;margin-left: 28.255vw;margin-top: 3.385vw;">
            <div>
                <img
                    class="section4-img"
                    alt=""
                    src="/images/alumni/section3/MariamGyulumyan.png"
                />
            </div>
            <div
                style="
            margin-left: 3.309vw;
        "
            >
                <img
                    class="section4-img"
                    alt=""
                    src="/images/alumni/section3/LeandroCiappina.png"
                />
            </div>
        </div>

        <div
            style="
        margin-left: 6.022vw;
        margin-top: 5.955vw;
    "
        >
            <h1
                style="color: rgba(124, 193, 255, 0.2);
                font-size: 14.562vw;
                font-weight: bold;
                line-height: 12.236vw;
                letter-spacing: 0.3vw;"
            >
                Lifelong<br /> Learning
            </h1>
        </div>
        <div style="width:89.789vw;">
            <p
                style="font-size: 2.316vw;
                margin-top: -15.5vw;
                margin-left: 18vw;
                color: rgb(0, 32, 75);
                line-height: 2.91vw;"
            >
                At DraperU, we know that learning is a never ending part of the
                entrepreneurial journey. We’re here to offer insight and
                inspiration along the way.
            </p>
        </div>

        <div
            class="podcast"
            style="
        margin-top: 9vw;
        margin-left: 36.263vw;
    "
        >
            <p
                style="
                font-size: 2.978vw;
                color: #00204B;
                font-weight: 500;
            "
            >
                DRAPERU PODCAST
            </p>
            <img alt="" src="/images/alumni/section3/arrow.svg" width="100%" />
        </div>

        <div style="padding: 7vw;">
            <p
                style="
            font-size: 2.978vw;
            color: #00204B;
            font-weight: 500;text-transform: uppercase;
        "
            >
                The Expert’s Table
            </p>

            <div class="blog_contnet_holder">
                {#each blog as data, id}
                    <div class="blog_content_section">
                        <div class="blog-image-wrraper">
                            <img src={data.blogsimage} alt="" width="100%" />
                        </div>
                        <div style="margin:1vw 0">
                            <p style="color:#6B6B6B;font-size:1.058vw;">
                                {data.name}
                                <span>
                                    {data.date}
                                </span>
                            </p>
                        </div>
                        <div>
                            <h5
                                style="font-size:1.190vw;color:black;font-weight:600;"
                            >
                                {data.Title}
                            </h5>
                        </div>
                        <div style="display:flex;justify-content:end;margin-right: 1vw;">
                            <div
                                style="margin-right: 1vw;"
                                on:click={() => {
                                    if (data.like === false) {
                                        data.like = true;
                                    } else {
                                        data.like = false;
                                    }
                                }}
                            >
                                {#if data.like === false}
                                    <svg
                                        width="1.9vw"
                                        height="1.5vw"
                                        viewBox="0 0 22 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M2.21688 10.1999C0.0535382 7.26649 0.774652 2.86642 4.38022 1.39973C7.98579 -0.0669538 10.1491 2.86642 10.8702 4.33311C11.5914 2.86642 14.4758 -0.0669538 18.0814 1.39973C21.687 2.86642 21.687 7.26649 19.5236 10.1999C17.3603 13.1332 10.8702 19 10.8702 19C10.8702 19 4.38022 13.1332 2.21688 10.1999Z"
                                            stroke="black"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                {/if}
                                {#if data.like === true}
                                    <svg
                                        width="1.9vw"
                                        height="1.5vw"
                                        viewBox="0 0 22 20"
                                        fill="#3C74C0"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M2.21688 10.1999C0.0535382 7.26649 0.774652 2.86642 4.38022 1.39973C7.98579 -0.0669538 10.1491 2.86642 10.8702 4.33311C11.5914 2.86642 14.4758 -0.0669538 18.0814 1.39973C21.687 2.86642 21.687 7.26649 19.5236 10.1999C17.3603 13.1332 10.8702 19 10.8702 19C10.8702 19 4.38022 13.1332 2.21688 10.1999Z"
                                            stroke="#3C74C0"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                {/if}
                            </div>
                            <div>
                                <svg
                                    width="1.9vw"
                                    height="1.5vw"
                                    viewBox="0 0 16 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M15.4545 8.14737C15.5864 8.14737 15.7137 8.19712 15.813 8.2874C15.9124 8.37769 15.977 8.5024 15.9949 8.63848L16 8.71579V15.1579C16.0001 15.8855 15.7324 16.5854 15.252 17.1134C14.7717 17.6414 14.1154 17.9574 13.4182 17.9962L13.2727 18H2.72727C2.02897 18.0001 1.35726 17.721 0.850534 17.2203C0.343812 16.7196 0.0406928 16.0354 0.00363645 15.3087L0 15.1571V8.71503C0.000225234 8.57108 0.0528534 8.43258 0.147259 8.32749C0.241665 8.2224 0.370817 8.15855 0.508639 8.14883C0.646461 8.13912 0.782687 8.18426 0.889814 8.27514C0.996942 8.36602 1.06699 8.49587 1.08582 8.63848L1.09091 8.71579V15.1579C1.09086 15.59 1.24821 16.006 1.53118 16.3218C1.81414 16.6377 2.20161 16.8298 2.61527 16.8594L2.72727 16.8632H13.2727C13.6874 16.8632 14.0866 16.6992 14.3896 16.4044C14.6927 16.1095 14.8771 15.7057 14.9055 15.2746L14.9091 15.1579V8.71579C14.9091 8.56503 14.9666 8.42045 15.0689 8.31386C15.1711 8.20726 15.3099 8.14737 15.4545 8.14737ZM7.90109 0.0090948L7.94982 0.0022737L8.01236 0L8.056 0.00303154L8.12436 0.0151579L8.17382 0.0295579L8.21745 0.0462317L8.26836 0.0735157L8.30546 0.0977684L8.33309 0.118232L8.38545 0.165979L13.0138 4.98922C13.1117 5.09052 13.1691 5.22668 13.1744 5.3703C13.1798 5.51392 13.1328 5.65434 13.0428 5.76327C12.9528 5.87221 12.8266 5.94159 12.6895 5.95743C12.5524 5.97328 12.4147 5.93442 12.304 5.84867L12.2429 5.79335L8.54545 1.94021V12.1263C8.54545 12.2637 8.49771 12.3964 8.41108 12.4999C8.32444 12.6034 8.20477 12.6708 8.07418 12.6894L8 12.6947C7.86819 12.6947 7.74084 12.645 7.64151 12.5547C7.54217 12.4644 7.47756 12.3397 7.45964 12.2036L7.45455 12.1263V1.94021L3.75709 5.79335C3.66474 5.88961 3.5423 5.94814 3.41204 5.9583C3.28177 5.96845 3.15234 5.92955 3.04727 5.84867L2.98618 5.79335C2.89381 5.6971 2.83764 5.56951 2.8279 5.43376C2.81815 5.29802 2.85548 5.16314 2.93309 5.05364L2.98618 4.98922L7.61455 0.166737L7.69455 0.0985264L7.76364 0.0568421L7.82618 0.0303158L7.90109 0.00985264V0.0090948Z"
                                        fill="black"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                {/each}
            </div>
        </div>
    </div>
</div>

<div class="mobile">
    <NavbarMenu backgroundColor="transparent" stroke="black" />
</div>

<div class="mobile">
    <div class="back-img-mbl">
        <div>
            <p class="heading-mbl">ALUMNI</p>
        </div>
    </div>

    <div class="section2-mbl">
        <div>
            <p class="paragraph1-mbl">
                DraperU Superheroes are developing ground-breaking companies to
                help build a new future.
            </p>
        </div>

        <div class="main-border-mbl">
            <div class="border-div-mbl">
                <p class="border-text-mbl">3100<br />DRAPERU ALUMNI</p>
            </div>
            <div class="border-div-mbl">
                <p class="border-text-mbl">7000<br />NEW JOBS</p>
            </div>
            <div class="border-div-mbl">
                <p class="border-text-mbl">900M+<br />RAISED IN FUNDING</p>
            </div>
        </div>

        <div class="mobile-section" style="display: flex;">
            <div>
                <p class="mobile-heading2">ALUMNI <br /> SUPERSTARS</p>
                <p
                    style="margin-left: 15vw;color: rgba(0, 32, 75, 0.8);font-weight: 300;font-size: 3.889vw;width: 57.872vw;margin-top: 3.547vw;"
                >
                    By joining Draper University, you will be a part of this
                    alumni network that spans the globe.
                </p>
                <div
                    style="margin-left: 81.678vw;
                    width: 4.611vw;
                    margin-top: -27vw;"
                >
                    <img
                        src="/images/alumni/mobile/arrow.svg"
                        alt=""
                        width="100%"
                    />
                </div>
                <div class="slider_mob" style="width: 100vw;overflow-x: scroll;">
                    <div  style="display:inline-flex;">
                        {#each slider as i}
                            <div
                                style="position: relative;
                                margin-left: 14.2vw;"
                            >
                                <div
                                    style=" width: 61.667vw; margin-top: 15vw;"
                                >
                                    <img
                                        src={i.image}
                                        alt=" "
                                        style="width: 100%"
                                    />
                                </div>
                            </div>
                        {/each}
                    </div>
                </div>
            </div>
        </div>
        <div
            class={userMbl.view_all_mbl ? 'view_all_mbl' : 'view_less_mbl'}
            style="overflow: hidden;"
        >
            <div class="gallery-mbl">
                {#each section3 as data}
                    <div>
                        <div class="gallery_tab-mbl">
                            <img src={data.image} alt="" width="100%" />
                        </div>
                        <div>
                            <p style="
                            line-height: 3.953vw;
                        " class="sec3-name-mbl">{@html data.name}</p>
                        </div>
                        <div><p class="sec3-date-mbl">{data.date}</p></div>
                        <div>
                            <p class="sec3-content-mbl">{data.content}</p>
                        </div>
                    </div>
                {/each}
            </div>
        </div>

        {#if !userMbl.view_all_mbl}
            <button class="view-all-btn_mbl " on:click={toggleMbl}>
                <p class="view-text_mbl ">Show More</p>
                <div style="width: 1.5vw;
                margin-left: 1.98vw;
                margin-top: -1.5vw;">
                    <img
                        src="images/global_section/arrow.svg"
                        alt=""
                        width="100%"
                    />
                </div>
            </button>
        {/if}
        {#if userMbl.view_all_mbl}
            <button class="view-all-btn_mbl  " on:click={toggleMbl}>
                <p class="view-text_mbl ">Show Less</p>
                <div
                    style="width: 1.5vw;margin-left: 1.98vw;;transform: rotate(180deg);"
                >
                    <img
                        src="images/global_section/arrow.svg"
                        alt=""
                        width="100%"
                    />
                </div>
            </button>
        {/if}

        <div style="margin-top: 19.444vw;">
            <div style="position:relative;">
                <div class="img-wrraper-mbl">
                    <img src="/images/mobile.svg" alt="" width="100%" />
                </div>
                <div style="width: 81.944vw;margin:auto;margin-top:-17vw;">
                    <h1
                        style="font-size: 4.444vw;color: #00204B;width: 83.567vw;line-height: 6.944vw;font-weight: 300;"
                    >
                        <div
                            style="margin-left: 3vw;width: 18vw;margin-right: 20vw;margin-bottom: 2vw;/* color: #00204B; */display: inline-block;border-radius: 1.5vw;border-bottom: 0.7vw solid rgb(247, 224, 95);"
                        />
                        Behind every great founder lies an even more impressive journey.
                        For our alumni, the road to success can offer many valuable
                        lessons. Through our Alumni Spotlight series, we have the
                        opportunity to get a look behind the scenes at the stories
                        of these impressive founders. .
                    </h1>
                </div>
            </div>
        </div>

        <div style="display: flex;margin-left: 6.539vw;margin-top: 8.242vw;">
            <div>
                <img
                    class="section4-img-mbl"
                    alt=""
                    src="/images/alumni/section3/MariamGyulumyan.png"
                />
            </div>
            <div
                style="
            margin-left: 3.309vw;
        "
            >
                <img
                    class="section4-img-mbl"
                    alt=""
                    src="/images/alumni/section3/LeandroCiappina.png"
                />
            </div>
        </div>

        <div
            style="
            margin-top: 28.864vw;margin-left: 13.611vw;
                "
            >
            <h1
                style="color: rgba(124, 193, 255, 0.2);font-size: 16.667vw;font-weight: bold;line-height: 13.889vw;"
            >
                Lifelong<br /> Learning
            </h1>
        </div>
        <div style="width:89.789vw;">
            <p
                style="font-size: 4.444vw;margin-top: -4.119vw;margin-left: 9.722vw;color: rgb(0, 32, 75);width: 85.303vw;"
            >
                At DraperU, we know that learning is a never ending part of the
                entrepreneurial journey. We’re here to offer insight and
                inspiration along the way.
            </p>
        </div>

        <div
            style="
            margin-top: 1.847vw;margin-left: 22.500vw;
                "
            >
            <p
                style="
                    font-size: 5.556vw;color: rgb(0, 32, 75);font-weight: 500;
            "
            >
                DRAPERU PODCAST
            </p>
            <img
                style="
                width: 53.611vw;
                margin-top: -4vw;"
                alt=""
                src="/images/alumni/section3/arrow.svg"
            />
        </div>

        <div style="margin-left: 12.864vw;margin-top: 15.833vw;">
            <p
                style="
                    font-size: 5.556vw;color: rgb(0, 32, 75);font-weight: 500;
            "
            >
                THE EXPERT’s TABLE
            </p>

            <div style="width:100%;padding: 0vw 4vw;">
                <div>
                    {#each blog as data, id}
                        <div class="blog_content_section_mobile">
                            <div class="blog-image-wrraper_mobile">
                                <img
                                    src={data.blogsimage}
                                    alt=""
                                    width="100%"
                                />
                            </div>
                            <div style="margin:4vw 0">
                                <p
                                    style="color: rgb(107, 107, 107);font-size: 3.333vw;"
                                >
                                    {data.name}
                                    <span>
                                        {data.date}
                                    </span>
                                </p>
                            </div>
                            <div>
                                <h5
                                    style="font-size: 3.889vw;color: black;font-weight: 600;width: 74.894vw;"
                                >
                                    {data.Title}
                                </h5>
                            </div>
                            <div style="display:flex;justify-content:end">
                                <div
                                    style="width: 2vw;margin-right: 10vw;text-align: end;"
                                    on:click={() => {
                                        if (data.like === false) {
                                            data.like = true;
                                        } else {
                                            data.like = false;
                                        }
                                    }}
                                >
                                    {#if data.like === false}
                                        <svg
                                            width="4.069vw"
                                            height="3.664vw"
                                            viewBox="0 0 22 20"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M2.21688 10.1999C0.0535382 7.26649 0.774652 2.86642 4.38022 1.39973C7.98579 -0.0669538 10.1491 2.86642 10.8702 4.33311C11.5914 2.86642 14.4758 -0.0669538 18.0814 1.39973C21.687 2.86642 21.687 7.26649 19.5236 10.1999C17.3603 13.1332 10.8702 19 10.8702 19C10.8702 19 4.38022 13.1332 2.21688 10.1999Z"
                                                stroke="black"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                        </svg>
                                    {/if}
                                    {#if data.like === true}
                                        <svg
                                            width="4.069vw"
                                            height="3.664vw"
                                            viewBox="0 0 22 20"
                                            fill="#3C74C0"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M2.21688 10.1999C0.0535382 7.26649 0.774652 2.86642 4.38022 1.39973C7.98579 -0.0669538 10.1491 2.86642 10.8702 4.33311C11.5914 2.86642 14.4758 -0.0669538 18.0814 1.39973C21.687 2.86642 21.687 7.26649 19.5236 10.1999C17.3603 13.1332 10.8702 19 10.8702 19C10.8702 19 4.38022 13.1332 2.21688 10.1999Z"
                                                stroke="#3C74C0"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                        </svg>
                                    {/if}
                                </div>
                                <div
                                    style="width:2vw;text-align:end; margin-right:10vw;"
                                >
                                    <svg
                                        width="4.069vw"
                                        height="3.664vw"
                                        viewBox="0 0 16 18"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M15.4545 8.14737C15.5864 8.14737 15.7137 8.19712 15.813 8.2874C15.9124 8.37769 15.977 8.5024 15.9949 8.63848L16 8.71579V15.1579C16.0001 15.8855 15.7324 16.5854 15.252 17.1134C14.7717 17.6414 14.1154 17.9574 13.4182 17.9962L13.2727 18H2.72727C2.02897 18.0001 1.35726 17.721 0.850534 17.2203C0.343812 16.7196 0.0406928 16.0354 0.00363645 15.3087L0 15.1571V8.71503C0.000225234 8.57108 0.0528534 8.43258 0.147259 8.32749C0.241665 8.2224 0.370817 8.15855 0.508639 8.14883C0.646461 8.13912 0.782687 8.18426 0.889814 8.27514C0.996942 8.36602 1.06699 8.49587 1.08582 8.63848L1.09091 8.71579V15.1579C1.09086 15.59 1.24821 16.006 1.53118 16.3218C1.81414 16.6377 2.20161 16.8298 2.61527 16.8594L2.72727 16.8632H13.2727C13.6874 16.8632 14.0866 16.6992 14.3896 16.4044C14.6927 16.1095 14.8771 15.7057 14.9055 15.2746L14.9091 15.1579V8.71579C14.9091 8.56503 14.9666 8.42045 15.0689 8.31386C15.1711 8.20726 15.3099 8.14737 15.4545 8.14737ZM7.90109 0.0090948L7.94982 0.0022737L8.01236 0L8.056 0.00303154L8.12436 0.0151579L8.17382 0.0295579L8.21745 0.0462317L8.26836 0.0735157L8.30546 0.0977684L8.33309 0.118232L8.38545 0.165979L13.0138 4.98922C13.1117 5.09052 13.1691 5.22668 13.1744 5.3703C13.1798 5.51392 13.1328 5.65434 13.0428 5.76327C12.9528 5.87221 12.8266 5.94159 12.6895 5.95743C12.5524 5.97328 12.4147 5.93442 12.304 5.84867L12.2429 5.79335L8.54545 1.94021V12.1263C8.54545 12.2637 8.49771 12.3964 8.41108 12.4999C8.32444 12.6034 8.20477 12.6708 8.07418 12.6894L8 12.6947C7.86819 12.6947 7.74084 12.645 7.64151 12.5547C7.54217 12.4644 7.47756 12.3397 7.45964 12.2036L7.45455 12.1263V1.94021L3.75709 5.79335C3.66474 5.88961 3.5423 5.94814 3.41204 5.9583C3.28177 5.96845 3.15234 5.92955 3.04727 5.84867L2.98618 5.79335C2.89381 5.6971 2.83764 5.56951 2.8279 5.43376C2.81815 5.29802 2.85548 5.16314 2.93309 5.05364L2.98618 4.98922L7.61455 0.166737L7.69455 0.0985264L7.76364 0.0568421L7.82618 0.0303158L7.90109 0.00985264V0.0090948Z"
                                            fill="black"
                                        />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    {/each}
                </div>
            </div>
        </div>
    </div>
    
</div>
<div>
    <Footer />
</div>
<style>
    p{
        margin: 0;
        padding: 0;
    }
    .img-wrraper-mbl {
        width: 78vw;
        height: 46.914vw;
        border-radius: 0.993vw;
        overflow: hidden;
        margin-left: 11.944vw;
    }
    .back-img-desktop{
        height: 49.725vw;
        object-fit: cover;
        object-fit: cover;
        object-position: bottom;
    }
    .blog_contnet_holder {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }
    .blog_content_section {
        margin-top: 3.247vw;
        width: 24.338vw;
    }
    .blog-image-wrraper {
        width: 23.148vw;
        height: 13.228vw;
        overflow: hidden;
    }
    .heading {
        text-align: center;
        font-weight: 600;
        color: white;
        font-size: 4.63vw;
    }
    .paragraph1 {
        color: #00204b;
        font-size:1.984vw;
        text-align: center;
        margin-top: 7.340vw;
        line-height: 3.307vw;
        text-transform: uppercase;
    }
    .heading2 {
        margin-left: 5.757vw;
        padding-top: 20.381vw;
        font-weight: 500;
        color: rgba(0, 32, 75, 1);
        font-size: 2.976vw;
    }
    .slider-text {
        margin-left: 5.766vw;
        color: rgba(0, 32, 75, 0.8);
        font-weight: 300;
        font-size: 1.323vw;
        padding-top: 0.95vw;
    }
    .slider-arrow {
        width: 5.489vw;
        margin-top: 26.8vw;
        margin-left: 0.5vw;
    }
    .slider::-webkit-scrollbar {
        display: none;
    }
    .slider_mob::-webkit-scrollbar {
        display: none;
    }
    /* .slider-mob{
        scroll-behavior: smooth;
        overflow: hidden;
    } */
    .slider {
        display: flex;
        width: 67.5vw;
        height: 31.82vw;
        scroll-behavior: smooth;
        overflow: hidden;
        margin-top: -30vw;
        margin-left: 31.7vw;
    }
    .main-border {
        display: flex;
        margin-top: 5.033vw;
        justify-content: center;
    }
    .border-div {
        border: 0.198vw solid #BFD9F1;
        width: 26.799vw;
        height: 7.407vw;
    }
    .border-div:nth-child(1) {
        border-left: none;
        border-top: none;
    }
    .border-div:nth-child(2) {
        border-top: none;
        border-left: none;
    }
    .border-div:nth-child(3) {
        border-top: none;
        border-right: none;
        border-left: none;
    }
    .border-text {
        color: #00204b;
        font-size: 1.984vw;
        text-align: center;
        margin-top: 0.6vw;
        line-height: 2.81vw;
    }
    .slider-image {
        width: 17.999vw;
        margin-top: 2.5vw;
        height: 29.116vw;
    }
    .gallery {
        display: flex;
        flex-wrap: wrap;
        margin: auto;
        width: 84.333vw;
        margin-top: 9.072vw;
        gap: 2.218vw 5.206vw;
        justify-content: center;
    }
    .gallery_tab {
        width: 9.375vw;
        height: 9.375vw;
        border-radius: 1.042vw;
        overflow: hidden;
        margin-bottom: 2.083vw;
        position: relative;
    }
    .sec3-name {
        font-size: 1.499vw;
        font-weight: 600;
        line-height: 1.814vw;
        color: #00204b;
        height: 2.3vw;
        text-align: center;
    }
    .sec3-date {
        text-align: center;
        margin-top: 1.3vw;
        font-size: 0.899vw;
        color: #072c5e94;
        font-weight: 300;
    }
    .sec3-content {
        text-align: center;
        font-size: 0.899vw;
        color: #00204b;
        font-weight: 500;
    }
    .superhero-heading {
        font-size: 2.978vw;
        margin-left: 12.374vw;
        margin-top: 10.424vw;
        color: #00204b;
        text-transform: uppercase;
    }
    .img-wrraper {
        width: 26.171vw;
        border-radius: 0.993vw;
        overflow: hidden;
    }
    .section4-img {
        width: 19.984vw;
        height: 26.139vw;
    }
    .desktop {
        display: block;
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .mobile {
            display: block;
        }
    }

    .back-img-mbl {
        height: 178.056vw;
        background-image: url(/images/alumni/alumni.JPG);
        background-repeat: no-repeat;
        background-size: cover;
        position: relative;
        background-position: center;
    }
    .heading-mbl {
        width: 33.056vw;
        margin-left: 33.333vw;
        padding-top: 135vw;
        font-weight: 600;
        color: white;
        font-size: 8.333vw;
    }

    .paragraph1-mbl {
        color: #00204b;
        font-size: 4.444vw;
        text-align: center;
        width: 86vw;
        margin-top: 14.167vw;
        margin-left: 4.975vw;
    }
    .main-border-mbl {
        margin-top: 13.786vw;
        margin-left: 15vw;
    }
    .border-div-mbl {
        border: 1.5vw solid #7cc1ff75;
        width: 66vw;
        height: 25vw;
    }
    .border-div-mbl:nth-child(1) {
        border-top: none;
        border-right: none;
    }
    .border-div-mbl:nth-child(2) {
        border-right: none;
        border-top: none;
        border-bottom: none;
    }
    .border-div-mbl:nth-child(3) {
        border-bottom: none;
        border-right: none;
    }
    .border-text-mbl {
        color: #00204b;
        font-size: 5.556vw;
        font-weight: 500;
        text-align: center;
        padding-top: 4.998vw;
        width: 66vw;
    }
    .mobile-section {
        margin-top: 20vw;
    }
    .mobile-heading2 {
        padding-left: 15.011vw;
        font-weight: 500;
        background: linear-gradient(1.05deg, #00204b 50.19%, #00429b 99.35%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-size: 8.333vw;
    }
    .gallery-mbl {
        display: flex;
        flex-wrap: wrap;
        margin: auto;
        width: 97.333vw;
        margin-top: 19.444vw;
        gap: 11.344vw;
        justify-content: center;
    }
    .gallery_tab-mbl {
        width: 20.419vw;
        height: 20.419vw;
        border-radius: 1.042vw;
        overflow: hidden;
        margin-bottom: 2.083vw;
        position: relative;
    }
    .sec3-name-mbl {
        font-size: 3.267vw;
        font-weight: 500;
        color: #00204b;
        height: 3vw;
        text-align: center;
    }
    .sec3-date-mbl {
        text-align: center;
        margin-top: 4.537vw;
        font-size: 1.961vw;
        color: #072c5e94;
        font-weight: 300;
    }
    .sec3-content-mbl {
        text-align: center;
        font-size: 1.961vw;
        color: #00204b;
        font-weight: 500;
    }
    .view-all-btn_mbl {
        display: flex;
        border: none;
        background-color: transparent;
        margin: auto;
        margin-top: 4vw;
    }

    .view-text_mbl {
        color: #00204b;
        font-size: 3.056vw;
        font-weight: 600;
        margin-bottom: 0;
    }
    .view_all_mbl {
        height: 440vw;
    }
    .view_less_mbl {
        height: 155vw;
    }
    .section4-img-mbl {
        width: 39.886vw;
        height: 52.522vw;
    }
    .blog_content_section_mobile {
        margin-top: 6.222vw;
        width: 66vw;
        margin-bottom: 6vw;
    }
    .podcast img {
        width: 29vw;
    }
</style>
